/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface PostCorporationsCorporationIdAssetsNamesNotFound
 */
export interface PostCorporationsCorporationIdAssetsNamesNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof PostCorporationsCorporationIdAssetsNamesNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the PostCorporationsCorporationIdAssetsNamesNotFound interface.
 */
export function instanceOfPostCorporationsCorporationIdAssetsNamesNotFound(value: object): value is PostCorporationsCorporationIdAssetsNamesNotFound {
    return true;
}

export function PostCorporationsCorporationIdAssetsNamesNotFoundFromJSON(json: any): PostCorporationsCorporationIdAssetsNamesNotFound {
    return PostCorporationsCorporationIdAssetsNamesNotFoundFromJSONTyped(json, false);
}

export function PostCorporationsCorporationIdAssetsNamesNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCorporationsCorporationIdAssetsNamesNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PostCorporationsCorporationIdAssetsNamesNotFoundToJSON(json: any): PostCorporationsCorporationIdAssetsNamesNotFound {
    return PostCorporationsCorporationIdAssetsNamesNotFoundToJSONTyped(json, false);
}

export function PostCorporationsCorporationIdAssetsNamesNotFoundToJSONTyped(value?: PostCorporationsCorporationIdAssetsNamesNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

